import React from 'react'
import MaterialSymbol from '../material-symbol'

const Assignment = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="assignment" {...props} />
))

Assignment.displayName = 'Assignment'

export default Assignment
